import React, { useEffect, useState, useRef } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";

import { Typeahead } from "react-bootstrap-typeahead";
import ReactQuill from "react-quill";
import Select from "react-validation/build/select";

import { token } from "../Actions/AuthAction";
import { getUniversity } from "../Actions/CommonAction";
import { postDrive } from "../Actions/DriveAction";
import { useHistory } from "react-router";
import { getJobsList } from "../Actions/JobAction";
import CONFIG from "../../config";
import Swal from "sweetalert2";
const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

export const Add = (props) => {
  const [jobids, setjobids] = useState([]);
  const [approvedJob, setapprovedJob] = useState([]);
  const [venuestatus, setvenuestatus] = useState(false);
  const [institute, setinstitute] = useState([]);
  const [instituteOptions, setinstituteOptions] = useState([]);
  const [drivename, setdrivename] = useState(null);
  const [drivestartdate, setdrivestartdate] = useState(null);
  const [driveenddate, setdriveenddate] = useState(null);
  const [lastdateofapply, setlastdateofapply] = useState(null);
  const [expectedjoindate, setexpectedjoindate] = useState(null);
  const [selectionprocess, setselectionprocess] = useState(null);
  const [venue, setvenue] = useState(null);
  const [driveType, setdriveType] = useState(false);

  const form = useRef(null);
  const history = useHistory();

  useEffect(() => {
    getData();
    if (props.edit == true) {
      let tempjobdetails = [];
      let tempins = [];
      setdrivename(props.driveDetails.drivename);
      setdrivestartdate(props.driveDetails.drivestartdate.replace(" ", "T"));
      setdriveenddate(props.driveDetails.driveenddate.replace(" ", "T"));
      setlastdateofapply(props.driveDetails.lastdateofapply.split(" ")[0]);
      setexpectedjoindate(props.driveDetails.expectedjoindate.split(" ")[0]);
      setselectionprocess(props.driveDetails.selectionprocess);
      setdriveType(props.driveDetails.drivetype);
      setvenuestatus(props.driveDetails.venuestatus);
      props.driveDetails.jobdrivejobmaps.map((item, index) => {
        tempjobdetails.push(item.job);
        tempjobdetails[
          index
        ].name = `${item.job.jobid} | ${item.job.jobdesignation} | ${item.job.employee.companyname}`;
      });
      setjobids(tempjobdetails);
      props.driveDetails.jobdriveinstmaps.map((item, index) =>
        tempins.push({ name: item.institute.name, id: item.institute.id })
      );

      setinstitute(tempins);
      console.log(props.driveDetails);
    }
  }, []);
  const getData = () => {
    getInstituteOptions();
    getJobsList({ page: 0, token: token(), universitystatus: 2 }).then(
      (res) => {
        res.data.map(
          (item, index) =>
            (item.name = `#${item.jobid}) ${item.jobdesignation} , ${item.employee.companyname}`)
        );
        setapprovedJob(res.data);
        console.log("Approved", res.data);
      }
    );
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    form.current.validateAll();
    const driveDetails = {
      loginusertoken: token(),
      drivename: drivename,
      drivetype: driveType ? 2 : 1,
      drivestartdate: drivestartdate,
      driveenddate: driveenddate,
      lastdateofapply: lastdateofapply,
      expectedjoindate: expectedjoindate,
      selectionprocess: selectionprocess,
      venuestatus: venuestatus ? 1 : 0,
      venue: venue,
      instituteids: [],
      jobids: [],
    };
    driveType
      ? institute.map((item) => driveDetails.instituteids.push(item.id))
      : driveDetails.instituteids.push(Number(institute));
    jobids.map((item) => driveDetails.jobids.push(Number(item.jobid)));
    if (validateForm(driveDetails)) {
      postDrive(driveDetails).then((res) => {
        if (res.error) {
          console.log(res.error);
          Swal.fire("Error", res.error, "error");
        } else {
          Swal.fire("Success", "Your Drive has been posted.", "success");

          history.push("/drivelist");
        }
      });
    } else {
      Swal.fire("Error", "Kindly fill all the details", "error");
    }
  };
  const validateForm = (driveDetails) => {
    let ret = true;
    Object.keys(driveDetails).map((key, index) => {
      if (driveDetails[key] === null) {
        ret = false;
      }
    });
    return ret;
  };
  const getInstituteOptions = () => {
    getUniversity({ key: token(), page: -1 }).then((res) => {
      let data = [];
      if (res.error) {
        Swal.fire("Error", "No Institute Found", "error");
      } else {
        res.data.map((items) => {
          items.university.insts.map((item) =>
            data.push({
              name: `${item.name} (${items.university.university_name})`,
              id: item.id,
            })
          );
        });
        setinstituteOptions(data);
      }
    });
  };
  return (
    <React.Fragment>
      <div>
        <div className="row mb-4">
          <div className="col-md-12">
            <h4 className="table_heading position-relative">ADD DRIVE</h4>
          </div>
        </div>
        <div className="card formcard">
          <div className="card-body">
            <Form ref={form} onSubmit={handleSubmit}>
              <div className="row">
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputEmailAddress">
                    Drive Name{" "}
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    className="form-control rounded-pill"
                    value={drivename}
                    onChange={(e) => setdrivename(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputEmailAddress">
                    Drive Type{" "}
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <div className="form-check d-flex justify-content-start mt-3">
                    <label className="switch">
                      <input
                        type="checkbox"
                        value={driveType}
                        onChange={(e) => {
                          setdriveType(!driveType);
                          setinstitute([]);
                        }}
                      />
                      <span className="slider" />
                      <span className="text-danger font-weight-bold">*</span>
                    </label>
                    <label
                      className="form-check-label ml-3 w-75  d-block mar_45"
                      for="flexCheckDefault"
                    >
                      {driveType ? (
                        <>
                          <p className="mr-3">Pool</p>
                          <Typeahead
                            validations={[required]}
                            className="rounded-pill"
                            id="basic-typeahead-multiple"
                            labelKey="name"
                            multiple
                            onChange={setinstitute}
                            options={instituteOptions}
                            placeholder="Choose several Institute..."
                            selected={institute}
                          />
                        </>
                      ) : (
                        <>
                          <p className="mr-3">Single</p>
                          <select
                            className="form-control rounded-pill w-75"
                            onChange={(e) => setinstitute(e.target.value)}
                          >
                            <option hidden>Please Select Institute</option>
                            {instituteOptions.map((item) => (
                              <option value={item.id}>{item.name}</option>
                            ))}
                          </select>
                        </>
                      )}
                    </label>
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputEmailAddress">
                    Drive Start Date and Time{" "}
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    type="datetime-local"
                    className="form-control rounded-pill"
                    value={drivestartdate}
                    onChange={(e) => setdrivestartdate(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputEmailAddress">
                    Drive End Date and Time{" "}
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    type="datetime-local"
                    min={drivestartdate}
                    className="form-control rounded-pill"
                    value={driveenddate}
                    onChange={(e) => setdriveenddate(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputEmailAddress">
                    Last Date to Apply{" "}
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    type="date"
                    max={drivestartdate && drivestartdate.split("T")[0]}
                    className="form-control rounded-pill"
                    value={lastdateofapply}
                    onChange={(e) => setlastdateofapply(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label className="small mb-1" for="inputEmailAddress">
                    Expected Joining Date{" "}
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Input
                    validations={[required]}
                    type="date"
                    min={drivestartdate && drivestartdate.split("T")[0]}
                    className="form-control rounded-pill"
                    value={expectedjoindate}
                    onChange={(e) => setexpectedjoindate(e.target.value)}
                  />
                </div>
                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputPassword">
                    Selection Process{" "}
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={selectionprocess}
                    onChange={(e) => setselectionprocess(e)}
                  />
                </div>
                <div className="form-group col-md-12">
                  <div className="form-group col-md-12">
                    <div>
                      <label className="small mb-1" for="inputEmailAddress">
                        Location Type{" "}
                        <span className="text-danger font-weight-bold">*</span>
                      </label>
                    </div>
                    <label className="switch">
                      <input
                        type="checkbox"
                        value={venuestatus}
                        onChange={(e) => setvenuestatus(!venuestatus)}
                      />
                      <span className="slider" />

                      <span className="text-danger font-weight-bold">*</span>
                    </label>
                  </div>
                  <div className="form-group col-md-12">
                    {venuestatus ? (
                      <label className="switch">On Campus </label>
                    ) : (
                      <label className="switch">Off Campus </label>
                    )}
                  </div>

                  {venuestatus ? (
                    <select
                      className="form-control rounded-pill"
                      onChange={(e) => setvenue(Number(e.target.value))}
                    >
                      <option hidden>Please Select Venue</option>
                      {instituteOptions.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  ) : (
                    <div className="form-group col-md-12">
                      <label className="small mb-1" for="inputPassword">
                        Venue{" "}
                        <span className="text-danger font-weight-bold">*</span>
                      </label>
                      <ReactQuill
                        theme="snow"
                        value={venue}
                        onChange={(e) => setvenue(e)}
                      />
                    </div>
                  )}
                </div>

                <div className="form-group col-md-12">
                  <label className="small mb-1" for="inputEmailAddress">
                    Add Job{" "}
                    <span className="text-danger font-weight-bold">*</span>
                  </label>
                  <Typeahead
                    validations={[required]}
                    className="rounded-pill "
                    id="basic-typeahead-multiple"
                    labelKey="name"
                    multiple
                    onChange={setjobids}
                    options={approvedJob}
                    placeholder="Choose several Jobs..."
                    selected={jobids}
                  />
                </div>
                <div className="form-group col-md-12">
                  <div className="row">
                    {jobids.length != 0 &&
                      jobids.map((item, key) => (
                        <div key={key} className="col-md-3 jod-details-card">
                          <a
                            target="_blank"
                            className="job-drive-summary"
                            href={`/jobdetail/${item.jobid}`}
                          >
                            <div className="user-info">
                              <img
                                className="company_logo"
                                src={`${CONFIG.IMAGE_URL}/${item.employee.logo}`}
                              />
                              <div className="user-title">
                                <h3> {item.jobdesignation}</h3>
                                <p>{item.employee.companyname}</p>
                              </div>
                            </div>
                          </a>
                          <p>
                            Job ID: <span>{item.jobid} </span>
                          </p>
                          <p>
                            Salary:
                            <span>
                              {" "}
                              ₹{item.costtocompanyend.toLocaleString()}-
                              {item.costtocompanystart.toLocaleString()}
                            </span>
                          </p>
                          <p>
                            Job Type:<span>{item.jobtype}</span>
                          </p>
                          <p>
                            Location:{" "}
                            {item.joblocationmaps.map((item) => (
                              <span className="location-job">
                                {item.city.name}
                              </span>
                            ))}
                          </p>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="form-group col-md-12 mt-4 mb-0">
                  <button className="btn btn-primary-custom mx-2" type="submit">
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
